module.exports = __webpack_public_path__ + "img/facebook_icon.0b749d6e.png";